import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		message: null,
		cards: [],
		images: [],
		sources: [],
		loginLoading: true,
		storeSourcesLoaded: false,
		contentLoading: false,
		isCallbackRoute: false,
		user: null,
		access_token: sessionStorage.access_token || null
	},
	mutations: {
		setLoginLoading(state, data) {
			state.loginLoading = data
		},
		setSources(state, data) {
			state.sources = data
		},
		setSourceLoaded(state, status) {
			state.sources = state.sources.map(source => {
				if (source.id == status.id) {
					source.loaded = status.loaded
				}
				return source
			})
			var a = state.sources.filter(source => {
				return source.loaded < 100
			})
			state.storeSourcesLoaded = a.length == 0
		},
		isCallbackRoute(state, data) {
			state.isCallbackRoute = data
		},
		setAccessToken(state, data) {
			sessionStorage.access_token = data
			state.access_token = data
		},
		setContentLoading(state, data) {
			state.contentLoading = data
		},
		setUserState(state, data) {
			state.user = data
		},
		setMessage(state, message) {
			state.message = message
		},
		setCards(state, cards) {
			var dynamicSort = property => {
				var sortOrder = 1
				if (property[0] === '-') {
					sortOrder = -1
					property = property.substr(1)
				}
				return function(a, b) {
					var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
					return result * sortOrder
				}
			}
			// if (process.env.NODE_ENV == 'development') {
			// 	cards = cards.map(card => {
			// 		if (process.env.NODE_ENV == 'development') {
			// 			if (card.src.indexOf('http://api.meinbubu.de/') < 0) {
			// 				card.src = 'http://api.meinbubu.de/' + card.src
			// 			}
			// 		} else {
			// 			if (card.src.indexOf('http://api.mein-bubu.de/') < 0) {
			// 				card.src = 'http://api.mein-bubu.de/' + card.src
			// 			}
			// 		}
			// 		return card
			// 	})
			// }
			state.cards = cards.sort(dynamicSort('order'))
		},
		setImages(state, images) {
			var dynamicSort = property => {
				var sortOrder = 1
				if (property[0] === '-') {
					sortOrder = -1
					property = property.substr(1)
				}
				return function(a, b) {
					var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
					return result * sortOrder
				}
			}
			// if (process.env.NODE_ENV == 'development') {
			// 	images = images.map(image => {
			// 		if(process.env.NODE_ENV == 'development'){
			// 			if (image.src.indexOf('http://api.meinbubu.de/') < 0) {
			// 				image.src = 'http://api.meinbubu.de/' + image.src
			// 			}
			// 		}else{
			// 			if (image.src.indexOf('http://api.mein-bubu.de/') < 0) {
			// 				image.src = 'http://api.mein-bubu.de/' + image.src
			// 			}
			// 		}
			// 		return image
			// 	})
			// }
			state.images = images.sort(dynamicSort('order'))
		}
	},
	actions: {
		login(context) {
			context.commit('setLoginLoading', true)
			var domain = process.env.NODE_ENV == 'development' ? 'http://api.meinbubu.de/auth/authorize?callback_url=' + window.location.origin + '/callback/' : 'http://api.mein-bubu.de/auth/authorize?callback_url=' + window.location.origin + '/callback/'
			window.location.href = domain
		},
		logout(context) {
			context.commit('setLoginLoading', true)
			var domain = process.env.NODE_ENV == 'development' ? 'http://api.meinbubu.de/auth/logout' : 'http://api.mein-bubu.de/auth/logout'
			axios
				.get(domain)
				.then(() => {
					context.commit('setContentLoading', false)
					context.commit('setAccessToken', null)
					context.commit('setUserState', null)
					context.commit('setMessage', 'logged out')
				})
				.catch(() => {
					context.commit('setContentLoading', false)
					context.commit('setMessage', 'failed')
				})
		},
		getLoginState(context) {
			var access_token = context.state.access_token ? context.state.access_token : ''
			axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
			context.commit('setLoginLoading', true)
			var domain = process.env.NODE_ENV == 'development' ? 'http://api.meinbubu.de/auth/me' : 'http://api.mein-bubu.de/auth/me'
			axios
				.get(domain)
				.then(res => {
					context.commit('setUserState', res.data)
					context.commit('setLoginLoading', false)
				})
				.catch(() => {
					context.commit('setUserState', null)
					context.commit('setMessage', 'Please sign in')
					context.commit('setLoginLoading', false)
				})
		},
		getVacations(context) {
			context.commit('setContentLoading', true)
			var domain = process.env.NODE_ENV == 'development' ? 'http://api.meinbubu.de/vacation' : 'http://api.mein-bubu.de/vacation'
			axios
				.get(domain)
				.then(res => {
					context.commit('setCards', res.data)
					context.commit('setMessage', 'Vacations loaded')
					context.commit('setContentLoading', false)
				})
				.catch(() => {
					context.commit('setMessage', 'failed to load vacations')
					context.commit('setContentLoading', false)
				})
		},
		getVacation(context, id) {
			context.commit('setContentLoading', true)
			var domain = process.env.NODE_ENV == 'development' ? 'http://api.meinbubu.de/vacation/' + id : 'http://api.mein-bubu.de/vacation/' + id
			axios
				.get(domain)
				.then(res => {
					context.commit('setImages', res.data)
					context.commit('setMessage', 'Images loaded')
					context.commit('setContentLoading', false)
				})
				.catch(() => {
					context.commit('setMessage', 'failed to load images')
					context.commit('setContentLoading', false)
				})
		},
		save(context, obj) {
			context.commit('setContentLoading', true)
			var domain = process.env.NODE_ENV == 'development' ? 'http://api.meinbubu.de/vacation/upload' : 'http://api.mein-bubu.de/vacation/upload'

			const formData = new FormData()

			formData.append('image', obj.file)
			formData.append('title', obj.title)
			formData.append('isSpecific', obj.isSpecific)

			return axios
				.post(domain, formData, {
					headers: {
						'content-type': 'multipart/form-data'
					},
					onUploadProgress: progressEvent => {
						var status = {
							loaded: Math.round((progressEvent.loaded / progressEvent.total) * 100),
							id: obj.id
						}
						context.commit('setSourceLoaded', status)
					}
				})
				.then(() => {
					context.commit('setMessage', 'saved')
					context.commit('setContentLoading', false)
				})
				.catch(() => {
					context.commit('setMessage', 'failed')
					context.commit('setContentLoading', false)
				})
		},
		update(context, obj) {
			context.commit('setContentLoading', true)
			var domain = process.env.NODE_ENV == 'development' ? 'http://api.meinbubu.de/vacation/update' : 'http://api.mein-bubu.de/vacation/update'

			return axios
				.put(domain, obj, {
					headers: {
						'content-type': 'application/json'
					}
				})
				.then(() => {
					context.commit('setContentLoading', false)
					context.commit('setMessage', 'saved')
				})
				.catch(() => {
					context.commit('setContentLoading', false)
					context.commit('setMessage', 'failed')
				})
		},
		delete(context, obj) {
			context.commit('setContentLoading', true)
			var domain = process.env.NODE_ENV == 'development' ? 'http://api.meinbubu.de/vacation/delete' : 'http://api.mein-bubu.de/vacation/delete'

			return axios
				.delete(domain + '/' + obj.table + '/' + obj.id)
				.then(() => {
					context.commit('setMessage', 'saved')
					context.commit('setContentLoading', false)
				})
				.catch(() => {
					context.commit('setMessage', 'failed')
					context.commit('setContentLoading', false)
				})
		}
	}
})
